<template>
<div class="card">
    <div class="card-header">Salary Review</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="11"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="11" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row class="my-4">
                <b-col cols="12" lg="3">
                    <BaseTextOutput :value="request.audit.auditFinalClassification 
                        ? request.audit.auditFinalClassification : request.proposedClassification" label="Final Classification"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseTextOutput :value="getBargainingUnitText(request.bargainingUnit)" label="Bargaining Unit"/>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col cols="12" lg="3">
                    <BaseSelector v-model="request.compJustificationDocumentation"
                            :v="$v.request.compJustificationDocumentation"
                            label="Salary Recommendation"
                            slug="salaryRecommendation"
                            :options = justificationOptions />
                </b-col>
                <b-col cols="12" lg="3">
                     <BaseTextInput v-model="request.step"
                            :v="$v.request.step"
                            slug="step"
                            label="Recommended Step"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseMoneyInput v-model="request.rate"
                            :v="$v.request.rate"
                            slug="rate"
                            label="Recommended Rate"/>
                </b-col>
                <b-col cols="12" lg="3">
                    <BaseSelector v-model="request.hiringAction"
                            :v="$v.request.hiringAction"
                            label="Type of Hire"
                            slug="typeOfHire"
                            :options = actionOptions />
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="3">
                     <BaseTextInput v-model="request.amountOfChange"
                            :v="$v.request.amountOfChange"
                            slug="amountOfChange"
                            label="Recommended Amount of Change"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseSelector v-model="request.amountOfChangeUom"
                            :v="$v.request.amountOfChangeUom"
                            label="Recommended Amount of Change Unit of Measure"
                            slug="amountOfChangeUom"
                            :options = amountOfChangeOptions />
                </b-col>
                <b-col cols="12" lg="5">
                    <label>Is Recommended salary within division director delegation?</label><br/>
                    <b-form-checkbox
                        v-model="request.recommendedSalaryWithinDDDelegation"
                        :v="$v.request.recommendedSalaryWithinDDDelegation"
                        name="recommendedSalaryWithinDDDelegation">
                        Yes
                    </b-form-checkbox>
                </b-col>
            </b-row>

             <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.selectedCandidateName"
                                    :v="$v.request.selectedCandidateName"
                                    label="Selected Candidate Name"
                                    tip=""
                                    slug="candidateName"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.selectedCandidateEmail"
                                    :v="$v.request.selectedCandidateEmail"
                                    label="Selected Candidate Email"
                                    tip=""
                                    slug="candidateEmail"/>
                </b-col>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="request.selectedCandidateEmployeeId"
                                    :v="$v.request.selectedCandidateEmployeeId"
                                    label="Selected Candidate Employee ID"
                                    tip=""
                                    slug="candidateEmpId"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="4">
                    <BaseSelector v-model="request.flsaStatusValue"
                        :v="$v.request.flsaStatusValue"
                        label="FLSA Status"
                        slug="flsaStatus"
                        :options=flsaStatusOptions
                        tip="" />
                </b-col>

                <b-col cols="12" lg="4">
                    <BaseDateInput v-model="request.salaryReviewSupervisorDate"
                        :v="$v.request.salaryReviewSupervisorDate"
                        label="Date Sent to Hiring Supervisor for Review"
                        slug="hiring-sup-review"/>
                </b-col>
            </b-row>

            <div v-if="isExistingStateEmployee" style="background-color:WhiteSmoke; padding: 10px; margin-bottom:20px;">
                    <p><strong>Existing State Employees</strong></p>
                    <b-row>
                        <b-col cols="12">
                            <b-button type="button" variant="secondary" size="sm" class="mb-2" @click="defaultNoChange">No Change</b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <BaseClassificationSelector v-model="request.currentClassification"
                                                  :v="$v.request.currentClassification"
                                                  slug="classification"
                                                  :key="keys.currentClassification"
                                                  v-on:input='forceClassificationRerender'
                                                  label="Former/Current Classification"
                                                  sr="Search for Former/Current Classification"/>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="request.currentCompCode"
                                    :v="$v.request.currentCompCode"
                                    slug="currentCompCode"
                                    label="Former/Current Comp Code"/>
                        </b-col>
                        <b-col cols="12" lg="4">
                            <BaseDateInput v-model="request.eligibilityNextProgressIncreaseDate"
                                     :v="$v.request.eligibilityNextProgressIncreaseDate"
                                     label="Date of Eligibility for next progression increase"
                                     slug="next-progression-date"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="3">
                            <BaseTextInput v-model="request.currentStep"
                                    :v="$v.request.currentStep"
                                    slug="currentStep"
                                    :key="keys.currentStep"
                                    label="Former/Current Step"/>
                        </b-col>
                        <b-col cols="12" lg="3">
                            <BaseMoneyInput v-model="request.currentRate"
                                    :v="$v.request.currentRate"
                                    :key="keys.currentRate"
                                    slug="currentRate"
                                    label="Former/Current Rate"/>
                        </b-col>
                    </b-row>
            </div>

            <div>
                <b-row>
                    <b-col cols="12" lg="12">
                        <BaseParagraphInput v-model="request.hrInternalEquityComparisonAnalysis"
                            :v="$v.request.hrInternalEquityComparisonAnalysis"
                        label="HR Internal Equity and Comparison Analysis"
                        slug="hrInternalEquityComparisonAnalysis"
                        tip=""/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="6">
                        <BaseParagraphInput v-model="request.educationLevel"
                            :v="$v.request.educationLevel"
                        label="Education Level"
                        slug="educationLevel"
                        tip=""/>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <BaseParagraphInput v-model="request.yearsRelatedExperience"
                            :v="$v.request.yearsRelatedExperience"
                        label="Years of Related Experience"
                        slug="yearsRelatedExperience"
                        tip=""/>
                    </b-col>
                    <b-col cols="12" lg="6">
                        <BaseParagraphInput v-model="request.specialSkills"
                            :v="$v.request.specialSkills"
                        label="Special Skills"
                        slug="specialSkills"
                        tip=""/>
                    </b-col>
                </b-row>
            </div>

            <div  v-if="request.salaryReviewAudit === true && isApprover" style="background-color:#E8F8F5; padding: 10px; margin-bottom:20px;">
              <p><strong>Salary Review Approval</strong></p>
                 <b-row>
                    <b-col cols="12" lg="4">
                        <BaseSelector v-model="request.approvedSalaryRecommendation"
                                :v="$v.request.approvedSalaryRecommendation"
                                label="Approved Salary Recommendation"
                                slug="salaryRecommendation"
                                :options = justificationOptions />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.approvedStep"
                                :v="$v.request.approvedStep"
                                slug="approvedStep"
                                label="Approved Step"/>
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseMoneyInput v-model="request.approvedRate"
                                :v="$v.request.approvedRate"
                                slug="approvedRate"
                                label="Approved Rate"/>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="request.approvedAmountOfChange"
                                :v="$v.request.approvedAmountOfChange"
                                slug="approvedAmountOfChange"
                                label="Approved Amount of Change"/>
                    </b-col>
                    <b-col cols="12" lg="5">
                        <BaseSelector v-model="request.approvedAmountOfChangeUom"
                                :v="$v.request.approvedAmountOfChangeUom"
                                label="Approved Amount of Change Unit of Measure"
                                slug="approvedAmountOfChangeUom"
                                :options = amountOfChangeOptions />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <BaseParagraphInput v-model="request.salaryApprovalComments"
                            :v="$v.request.salaryApprovalComments"
                            slug="salaryApprovalComments"
                            label="Salary Approval Comments"/>
                    </b-col>
                </b-row>

            </div>

            <b-row style="margin-bottom:20px;">
                <b-col cols="12" lg="4">
                  <b-form-checkbox v-model="needSalaryReviewApproval" :v="$v.needSalaryReviewApproval" name="need-approval-switch" data-test="need-approval-switch" switch>
                    <b>Is Salary Approval Needed?</b>
                  </b-form-checkbox>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.salaryComments"
                        :v="$v.request.salaryComments"
                        slug="comments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>

            <div>
            <b-button type="button" variant="primary" @click="onSubmitForReview"
                    v-if="request.salaryReviewAudit !== true && needSalaryReviewApproval">Submit Salary Review for Review</b-button>
            <b-button type="button" variant="primary" @click="onSubmitApproved"
                      v-if="request.salaryReviewAudit !== true && !needSalaryReviewApproval">Complete Salary Review without Approval</b-button>

            <span v-if="request.salaryReviewAudit === true && isApprover">
                <b-button type="button" variant="primary" @click="onSubmitApproved"
                          v-if="needSalaryReviewApproval">Approve Salary Review</b-button>
                <b-button type="button" variant="primary" @click="onSubmitReturn"
                     >Return Salary Review to Staffing Specialist</b-button>
                <b-button type="button" variant="primary" @click="onSubmitSave"
                      v-if="needSalaryReviewApproval">Save</b-button>
            </span>


            <b-button type="button" variant="outline-primary" @click="save" v-if="request.salaryReviewAudit == null">Save</b-button>
            <b-button type="button" variant="outline-primary" @click="repost">Repost Position</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, decimal, numeric, minValue, maxValue, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"
import { commonOptions } from '@/mixins/commonOptions.js'
import {roleService} from "@/mixins/roleService";


export default {
    components: {
        LifecycleCheckList,
    },
    mixins: [
       commonOptions,
       roleService,
    ],
    props: {
        request: Object
    },
    data() {
        return {
            checklistComplete: false,
            comments: '',
            saveOnly: false,
            noChange: false,
            needSalaryReviewApproval: true,
            justificationOptions: [
                { value: 'N/A', text: 'N/A' },
                { value: 'Provided', text: 'Provided' }
            ],
            actionOptions: [
                { value: 'Conversion', text: 'Conversion' },
                { value: 'Data Change', text: 'Data Change' },
                { value: 'Demotion', text: 'Demotion' },
                { value: 'Hire', text: 'Hire' },
                { value: 'Reinstatement', text: 'Reinstatement' },
                { value: 'Re-hire', text: 'Re-hire' },
                { value: 'Lay Off', text: 'Lay Off' },
                { value: 'Mobility', text: 'Mobility' },
                { value: 'Movement', text: 'Movement' },
                { value: 'Position Change', text: 'Position Change' },
                { value: 'Post Retirement Option (PRO)', text: 'Post Retirement Option (PRO)' },
                { value: 'Promotion', text: 'Promotion' },
                { value: 'Reallocation', text: 'Reallocation' },
                { value: 'Reassignment', text: 'Reassignment' },
                { value: 'Suspension', text: 'Suspension' },
                { value: 'Transfer', text: 'Transfer' },
                { value: 'Work Out of Class', text: 'Work Out of Class' },
                { value: 'Bidder', text: 'Bidder' },
                { value: 'Interest Bidder', text: 'Interest Bidder' },
                { value: 'Connect 700', text: 'Connect 700'},
                { value: 'Other', text: 'Other' },
            ],
            amountOfChangeOptions: [
                { value: 'P', text: 'Percent' },
                { value: 'S', text: 'Step' },
            ],
            keys: {
                currentClassification: 0,
                currentRate: 0,
                currentStep: 0
            },
        }
    },
     validations() {
        return {
            comments: { required: false, maxLength: maxLength(4000) },
            checklistComplete: { checked: value => value === true },
            needSalaryReviewApproval: {required},
            request: {
                salaryComments: { required: requiredIf(function (){
                  return !this.needSalaryReviewApproval
                  }), maxLength: maxLength(4000) },
                compJustificationDocumentation: { maxLength: maxLength(15),
                    required,
                 },
                step: { maxLength: maxLength(3),
                    required,
                 },
                rate: { decimal,
                    required,
                 },
                hiringAction: { required },
                selectedCandidateEmail: { maxLength: maxLength(75),
                    required
                 },
                selectedCandidateName: { maxLength: maxLength(75),
                    required,
                 },
                selectedCandidateEmployeeId: { required: requiredIf(function () {
                        return this.isExistingStateEmployee
                    }),
                    maxLength: maxLength(75) },
                flsaStatusValue: { required },
                salaryReviewSupervisorDate: { required },
                amountOfChangeUom: { required },
                amountOfChange: { required },
                currentClassification: { required: false
                },
                eligibilityNextProgressIncreaseDate: { required: false
                },
                currentRate: { decimal,
                    required: false
                },
                currentStep: { required: false
                },
                hrInternalEquityComparisonAnalysis: { required },
                educationLevel: { required },
                yearsRelatedExperience: { required },
                specialSkills: { required },
                recommendedSalaryWithinDDDelegation: { required : true },
                currentCompCode: { required: false,
                    maxLength: maxLength(3)
                },
                approvedRate: { decimal,
                    required: requiredIf(function () {
                        return this.request.salaryReviewAudit === true && this.isApprover
                    })
                },
                approvedStep: { required: requiredIf(function () {
                        return this.request.salaryReviewAudit === true && this.isApprover
                    })
                },
                approvedSalaryRecommendation: { required: requiredIf(function () {
                        return this.request.salaryReviewAudit === true && this.isApprover
                    })
                },
                approvedAmountOfChangeUom: { required: requiredIf(function () {
                        return this.request.salaryReviewAudit === true && this.isApprover
                    })
                },
                approvedAmountOfChange: { required: requiredIf(function () {
                        return this.request.salaryReviewAudit === true && this.isApprover
                    })
                },
                salaryApprovalComments: { required : false }
            }
        }
     },
    computed: {
        isApprover: function() {
            return (this.request.salaryReviewAudit === true && this.isSalary())
        },
        isExistingStateEmployee: function() {
            return (this.request.hiringAction &&
                        !(['Hire', 'Connect 700', 'Other'].indexOf(this.request.hiringAction) >= 0))
        }
    },
    created() {
      if(this.request.needSalaryReviewApproval != null) {
        this.needSalaryReviewApproval = this.request.needSalaryReviewApproval
      }

      if (this.isApprover && this.request.salaryReviewAudit === true) {
          if (!this.request.approvedStep) {
              this.request.approvedStep = this.request.step
          }
          if (!this.request.approvedRate) {
              this.request.approvedRate = this.request.rate
          }
          if (!this.request.approvedSalaryRecommendation) {
              this.request.approvedSalaryRecommendation = this.request.compJustificationDocumentation
          }
          if (!this.request.approvedAmountOfChange) {
              this.request.approvedAmountOfChange = this.request.amountOfChange
          }
          if (!this.request.approvedAmountOfChangeUom) {
              this.request.approvedAmountOfChangeUom = this.request.amountOfChangeUom
          }
      }
    },
            
    mounted: function() {
        this.autosave()
    },
    
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },
    


    methods: {
        forceClassificationRerender(event) {
            this.keys.currentClassification += 1
        },

        defaultNoChange() {
            if (this.request.audit) {
                this.request.currentClassification = this.request.audit.auditFinalClassification
                this.keys.currentClassification += 1
            }

            this.request.currentRate = this.request.rate
            this.request.currentStep = this.request.step
            this.noChange = true
            this.keys.currentRate += 1
            this.keys.currentStep += 1
        },

        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },

        save() {
          this.saveOnly = true
          this.onSubmitForReviewWithSaveOnly(true)
          this.saveOnly = false
        },

        onSubmitForReview(){
          this.onSubmitForReviewWithSaveOnly(false);
        },

        onSubmitForReviewWithSaveOnly(saveOnly) {
            if (!saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                compJustificationDocumentation: this.request.compJustificationDocumentation,
                step: this.request.step,
                rate: this.request.rate,
                hiringAction: this.request.hiringAction,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,
                flsaStatusValue: this.request.flsaStatusValue,
                amountOfChangeUom: this.request.amountOfChangeUom,
                amountOfChange: this.request.amountOfChange,
                salaryReviewSupervisorDate: this.request.salaryReviewSupervisorDate,
                comments: this.request.salaryComments,
                nextLifecycle: '12',
                advanceNextLifecycle: false,
                needSalaryReviewApproval: this.needSalaryReviewApproval,
                saveOnly: this.saveOnly,

                currentClassification: this.request.currentClassification,
                currentCompCode: this.request.currentCompCode,
                currentStep: this.request.currentStep,
                currentRate: this.request.currentRate,

                eligibilityNextProgressIncreaseDate: this.request.eligibilityNextProgressIncreaseDate,
                recommendedSalaryWithinDDDelegation: this.request.recommendedSalaryWithinDDDelegation,
                hrInternalEquityComparisonAnalysis: this.request.hrInternalEquityComparisonAnalysis,
                specialSkills: this.request.specialSkills,
                yearsRelatedExperience: this.request.yearsRelatedExperience,
                educationLevel: this.request.educationLevel,
                approvedSalaryRecommendation: this.request.approvedSalaryRecommendation,
                approvedStep: this.request.approvedStep,
                approvedRate: this.request.approvedRate,
                approvedAmountOfChangeUom: this.request.approvedAmountOfChangeUom,
                approvedAmountOfChange: this.request.approvedAmountOfChange,
                salaryApprovalComments: this.request.salaryApprovalComments,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/salaryReview`, payload)
                .then(response => {
                    if(saveOnly === false){
                        this.showRootToast("Salary has been submitted to HR Supervisor.", "Success", "success")
                    }
                    else{
                        this.showRootToast("HRM Request Has Been Saved", "Success", "success")
                    }
                    this.$router.push('/home')
                })

        },

        onSubmitReturn() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                compJustificationDocumentation: this.request.compJustificationDocumentation,
                step: this.request.step,
                rate: this.request.rate,
                hiringAction: this.request.hiringAction,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,
                flsaStatusValue: this.request.flsaStatusValue,
                amountOfChangeUom: this.request.amountOfChangeUom,
                amountOfChange: this.request.amountOfChange,
                salaryReviewSupervisorDate: this.request.salaryReviewSupervisorDate,
                comments: this.request.salaryComments,
                nextLifecycle: '12',
                advanceNextLifecycle: false,
                currentClassification: this.request.currentClassification,
                currentCompCode: this.request.currentCompCode,
                currentStep: this.request.currentStep,
                currentRate: this.request.currentRate,

                eligibilityNextProgressIncreaseDate: this.request.eligibilityNextProgressIncreaseDate,
                recommendedSalaryWithinDDDelegation: this.request.recommendedSalaryWithinDDDelegation,
                hrInternalEquityComparisonAnalysis: this.request.hrInternalEquityComparisonAnalysis,
                approvedSalaryRecommendation: this.request.approvedSalaryRecommendation,
                approvedStep: this.request.approvedStep,
                approvedRate: this.request.approvedRate,
                approvedAmountOfChangeUom: this.request.approvedAmountOfChangeUom,
                approvedAmountOfChange: this.request.approvedAmountOfChange,
                salaryApprovalComments: this.request.salaryApprovalComments,
            }


            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/salaryReview/return`, payload)
                .then(response => {
                    this.showRootToast("HRM Request Has Been Returned to Staffing Specialist", "Success", "success")
                    this.$router.push('/home')
            })
        },

        onSubmitSave() {
            this.saveOnly = false
            this.$refs.checklist.emitCheckListStatus()
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$nextTick(() => {
                    document.getElementById('form-container').scrollIntoView()
                })
                return
            }

            let payload = {
                requestId: this.request.id,
                compJustificationDocumentation: this.request.compJustificationDocumentation,
                step: this.request.step,
                rate: this.request.rate,
                hiringAction: this.request.hiringAction,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,
                flsaStatusValue: this.request.flsaStatusValue,
                amountOfChangeUom: this.request.amountOfChangeUom,
                amountOfChange: this.request.amountOfChange,
                salaryReviewSupervisorDate: this.request.salaryReviewSupervisorDate,
                comments: this.request.salaryComments,
                nextLifecycle: '12',
                advanceNextLifecycle: false,
                needSalaryReviewApproval: this.needSalaryReviewApproval,
                saveOnly: this.saveOnly,

                currentClassification: this.request.currentClassification,
                currentCompCode: this.request.currentCompCode,
                currentStep: this.request.currentStep,
                currentRate: this.request.currentRate,

                eligibilityNextProgressIncreaseDate: this.request.eligibilityNextProgressIncreaseDate,
                recommendedSalaryWithinDDDelegation: this.request.recommendedSalaryWithinDDDelegation,
                hrInternalEquityComparisonAnalysis: this.request.hrInternalEquityComparisonAnalysis,
                specialSkills: this.request.specialSkills,
                yearsRelatedExperience: this.request.yearsRelatedExperience,
                educationLevel: this.request.educationLevel,
                approvedSalaryRecommendation: this.request.approvedSalaryRecommendation,
                approvedStep: this.request.approvedStep,
                approvedRate: this.request.approvedRate,
                approvedAmountOfChangeUom: this.request.approvedAmountOfChangeUom,
                approvedAmountOfChange: this.request.approvedAmountOfChange,
                salaryApprovalComments: this.request.salaryApprovalComments,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/salaryReview`, payload)
                .then(response => {
                    this.showRootToast("HRM Request Has Been Saved", "Success", "success")
                    this.$router.push('/home')
                })

        },

        onSubmitApproved() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                compJustificationDocumentation: this.request.compJustificationDocumentation,
                step: this.request.step,
                rate: this.request.rate,
                hiringAction: this.request.hiringAction,
                selectedCandidateEmail: this.request.selectedCandidateEmail,
                selectedCandidateName: this.request.selectedCandidateName,
                selectedCandidateEmployeeId: this.request.selectedCandidateEmployeeId,
                flsaStatusValue: this.request.flsaStatusValue,
                amountOfChangeUom: this.request.amountOfChangeUom,
                amountOfChange: this.request.amountOfChange,
                salaryReviewSupervisorDate: this.request.salaryReviewSupervisorDate,
                comments: this.request.salaryComments,
                nextLifecycle: '12',
                advanceNextLifecycle: true,
                needSalaryReviewApproval: this.needSalaryReviewApproval,

                currentClassification: this.request.currentClassification,
                currentCompCode: this.request.currentCompCode,
                currentStep: this.request.currentStep,
                currentRate: this.request.currentRate,

                eligibilityNextProgressIncreaseDate: this.request.eligibilityNextProgressIncreaseDate,
                recommendedSalaryWithinDDDelegation: this.request.recommendedSalaryWithinDDDelegation,
                hrInternalEquityComparisonAnalysis: this.request.hrInternalEquityComparisonAnalysis,
                approvedSalaryRecommendation: this.request.approvedSalaryRecommendation,
                approvedStep: this.request.approvedStep,
                approvedRate: this.request.approvedRate,
                approvedAmountOfChangeUom: this.request.approvedAmountOfChangeUom,
                approvedAmountOfChange: this.request.approvedAmountOfChange,
                salaryApprovalComments: this.request.salaryApprovalComments,
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/salaryReview/approve`, payload)
                  .then(response => {
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    }
                  })

        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },

        repost() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '07'
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    this.$router.push('/home') 
                }) 
        },

        getBargainingUnitText(bargainingUnitCode){
            return this.bargainingUnitOptions.find(code => code.value === bargainingUnitCode).text
        }
    }
}
</script>
